import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogTitle,
  Typography,
  LinearProgress,
  Button,
  CircularProgress,
} from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  loadingDialog: {
    backgroundColor: theme.palette.loaderColor.main,
    color: "white",
    "& .progress": {
      backgroundColor: "inherit",
    },
  },
}));

const LoadingButton = ({
  id="loadingButton",
  isvalid,
  loading,
  value,
  btndisabled,
  hideButton,
  hideModel,
  loaderText = 'Your site will be ready in few seconds...',
  ...restProps
}) => {
  const classes = useStyles();

  const disabled = loading || btndisabled ? true : false;
  return (
    <Fragment>
      {!hideModel && (
        <Dialog
          open={Boolean(loading)}
          PaperProps={{
            className: classes.loadingDialog,
          }}
        >
          <DialogTitle disableTypography>
            <Typography color="inherit">{loaderText}</Typography>
          </DialogTitle>
          <LinearProgress variant="query" className="progress" />
        
        </Dialog>
      )}
      {!hideButton && (
        <Button aria-label={value} id={id} {...restProps} disabled={disabled}>
          {value}
          {loading && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
        </Button>
      )}
    </Fragment>
  );
};

export default LoadingButton;
